import { isPhotoUrl } from '../lib/helpers.js';
import { INIT_FILTERS } from '../lib/constants.js';
export function FilterTile({filter,emoji,size=100}){
  const f=filter||INIT_FILTERS[0];
  const isUrl=isPhotoUrl(emoji);
  // I filtri più vecchi hanno solo vig/grain come sì/no (true = pieno, cioè 1);
  // quelli creati con lo slider nuovo portano vigAmt/grainAmt (0..1) — se
  // c'è quel valore preciso lo usiamo, altrimenti si ricade sul vecchio
  // comportamento binario, così niente si rompe per i filtri già esistenti.
  const vigAmt=f.vigAmt!==undefined&&f.vigAmt!==null?f.vigAmt:(f.vig?1:0);
  const grainAmt=f.grainAmt!==undefined&&f.grainAmt!==null?f.grainAmt:(f.grain?1:0);
  return(
    <div style={{width:size,height:size,borderRadius:size*0.14,position:"relative",overflow:"hidden",display:"flex",alignItems:"center",justifyContent:"center",background:"linear-gradient(135deg,#2E2E36,#16161C)",flexShrink:0}}>
      {isUrl
        ? <img src={emoji} style={{position:"absolute",inset:0,width:"100%",height:"100%",objectFit:"cover",filter:f.css&&f.css!=="none"?f.css:"none",zIndex:1}}/>
        : <div style={{fontSize:size*0.5,filter:f.css&&f.css!=="none"?f.css:"none",position:"relative",zIndex:1,lineHeight:1}}>{emoji}</div>}
      {f.tint&&<div style={{position:"absolute",inset:0,background:f.tint,mixBlendMode:"overlay",zIndex:2,pointerEvents:"none"}}/>}
      {vigAmt>0&&<div style={{position:"absolute",inset:0,background:`radial-gradient(ellipse at center, transparent 38%, rgba(0,0,0,${0.5*vigAmt}) 100%)`,zIndex:3,pointerEvents:"none"}}/>}
      {grainAmt>0&&<div style={{position:"absolute",inset:0,opacity:0.15*grainAmt,zIndex:4,pointerEvents:"none",backgroundImage:"repeating-radial-gradient(circle,#fff 0,transparent 1px)",backgroundSize:"3px 3px"}}/>}
    </div>
  );
}
